// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Em-z","badgeLink":"Fm-z","category":"Gm-z"};